import gql from 'graphql-tag';

export const FRAGMENT_CONTENT_VALIDATION = gql`
  fragment ContentValidation on ContentValidation {
    label
    reason
    reasonDetails
  }
`;

export const FRAGMENT_AB_TEST = gql`
  fragment AbTest on AbTest {
    name
    value
  }
`;
